import React from 'react';
import {ScrollView} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {FlexView, Spacer, Spacing} from '/component/base/Storybook';

import Default from './Default';
import Shadow from './Shadow';

storiesOf('base', module).add('Card', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Default />
        <Spacer size={24} />
        <Shadow />
      </FlexView>
    </Spacing>
  </ScrollView>
));
